import { render, staticRenderFns } from "./JypxList.vue?vue&type=template&id=42c3f5e2&scoped=true"
import script from "./JypxList.vue?vue&type=script&lang=js"
export * from "./JypxList.vue?vue&type=script&lang=js"
import style0 from "./JypxList.vue?vue&type=style&index=0&id=42c3f5e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3f5e2",
  null
  
)

export default component.exports